import {
  Component,
  Input,
  HostBinding,
  OnChanges,
  SimpleChanges,
  DoCheck,
  inject
} from '@angular/core';
import { UntypedFormArray } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { CheckboxQuestionV3 } from '../../../classes/question-checkbox';
import { QuestionBaseV3ComponentDirective } from '../question-base.component';

@Component({
  selector: 'bepatient-input-checkbox-v3',
  templateUrl: './input-checkbox.component.html',
  styleUrls: ['./input-checkbox.component.scss'],
  standalone: false
})
export class InputCheckboxComponentV3
  extends QuestionBaseV3ComponentDirective
  implements OnChanges, DoCheck
{
  private sanitizer = inject(DomSanitizer);

  private _question: CheckboxQuestionV3;
  dirty: boolean;

  @Input() color: string;
  @Input() question: CheckboxQuestionV3;

  @HostBinding('attr.style')
  get valueAsStyle(): any {
    return this.sanitizer.bypassSecurityTrustStyle(
      `--data-color-checked: ${this.color}`
    );
  }

  get options() {
    const formArray = this.formGroup.get(this.question.key) as UntypedFormArray;
    return formArray.controls;
  }

  get value() {
    return this.formGroup.get(this.question.key).value;
  }

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);
    if (changes.formGroup.currentValue && this.question) {
      /*
          By default, empty values are string ""
          those strings are interpreted as value by the template.
          Hence checkboxes are checked.

          That's the reason why we change these strings to
          booleans
        */

      const parsedValue = this.formGroup
        .get(this.question.key)
        .value.map(v => !!v);

      this.formGroup.patchValue(
        { [this.question.key]: parsedValue },
        { emitEvent: false }
      );
    }
  }

  isChecked(): void {
    this.formGroup.get(this.question.key).markAsTouched();
    this.dirty = this.formGroup.get(this.question.key).dirty;
    setTimeout(() => {
      const parsedValue = this.formGroup
        .get(this.question.key)
        .value.map(v => !!v);
      this.formGroup.patchValue({ [this.question.key]: parsedValue });
    }, 0);
  }

  ngDoCheck(): void {
    this.dirty = this.formGroup.get(this.question.key).dirty;
  }
}
